var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { PopupController } from "./PopupController";
import { observer } from "mobx-react";
import { PopupPortal, Overlay, Content, CloseButton } from "./components";
function getPopupDefaultConfig() {
    return {
        hasOverlay: true,
        popupPortalEl: window.document.body,
        className: "",
        hasCloseBtn: true
    };
}
let Popup = class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.state = { controller: new PopupController(Object.assign(Object.assign({}, getPopupDefaultConfig()), props.config)) };
        this.closeHandler = this.state.controller.hide.bind(this.state.controller);
    }
    componentDidMount() {
        this.state.controller.show();
    }
    componentWillUnmount() {
        this.state.controller.hide();
    }
    render() {
        let overlayClass = this.state.controller.config.hasOverlay ? "rj-popup-portal--hasOverlay" : "";
        let customClass = this.state.controller.setClassName;
        let closeBtnClass = this.state.controller.config.hasCloseBtn ? `rj-popup-message__hasCloseBtn ${customClass}` : customClass;
        return (this.state.controller.shouldShow &&
            React.createElement(PopupPortal, { popupPortalEl: this.state.controller.config.popupPortalEl, className: `${overlayClass} ${this.state.controller.config.className}` },
                React.createElement(Overlay, { onTouchMove: this.state.controller.eventHandlers.mobileScrollHandling.preventScroll, onClick: this.state.controller.config.closeFromOverlay ? this.closeHandler : () => { } }),
                React.createElement(Content, { className: closeBtnClass, onTouchStart: this.state.controller.eventHandlers.mobileScrollHandling.touchStartHandler, onTouchMove: this.state.controller.eventHandlers.mobileScrollHandling.touchMoveHandler, top: this.state.controller.contentElTop[0] },
                    this.state.controller.config.hasCloseBtn && React.createElement(CloseButton, { onClick: this.closeHandler }),
                    this.props.children)));
    }
};
Popup = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], Popup);
export { Popup };
//# sourceMappingURL=Popup.js.map